<template>
  <div class="header-menu">
    <!-- <i @click="goBack" class="fa fa-arrow-right"></i> -->
    <div class="arrow-bake-menu" @click="goBack">
      <BaseIcon
        v-if="viewArrow && arrow"
        class="icon-menu-outer icon-back"
        width="18"
        height="14"
        nameIcon="arrow-back"
        pathIcon="icons-ganeral"
      />
    </div>
    <BaseIcon
      v-if="!viewArrow"
      class="icon-menu-outer icon-menu"
      @click="goToHomePage"
      width="5"
      height="17"
      nameIcon="icon-menu-black"
      pathIcon="icons-ganeral"
    />

    <div class="h-100 flex flex-align-center mrg-l-6">
      <baseIcon
        v-if="!arrow"
        width="20"
        height="20"
        pathIcon="icons"
        nameIcon="support"
      />
    </div>
    <div class="title" :class="{ 'a-right': viewArrow }">{{ title }}</div>

    <!-- <i @click="goToHomePage" class="fa fa-close"></i> -->
    <div
      v-show="!$_mobile"
      class="x-close-menu close-popup otz-icon"
      @click="goToHomePage"
    >
      F
    </div>
  </div>
</template>

<script>
import menuService from "@/services/menu";
// import { mapActions, mapState } from "vuex";
export default {
  name: "HeaderMenu",
  props: {
    title: String,
    routeBackName: String,
    arrow: {
      default: true,
    },
  },
  computed: {
    viewArrow() {
      if (this.routeBackName != "") return true;
      else return false;
    },
  },
  methods: {
    // ...mapActions("bookList", ["setSettingsSearchTo"]),
    goBack() {
      menuService.openAt(this.routeBackName);
      // if (this.routeBackName == "main-tools") {
      //   this.setSettingsSearchTo("");
      // }
      // this.$router.push({ name: this.routeBackName });
    },
    goToHomePage() {
      menuService.closeMenu();
      // this.setSettingsSearchTo("");
      // this.$router.push({ name: "main" });
    },
  },
};
</script>

<style lang="scss">
.header-menu {
  display: flex;
  // height: 40px;
  // justify-content: space-between;
  width: -webkit-fill-available;
  height: 56px;
  background-color: #dedede;
  line-height: 56px;
  padding: 0 18px 0 0;
  font-size: 14px;
  font-weight: 500;
  .title {
    flex-grow: 1;
    color: #000;
    font-size: 14px;
  }
  .icon-menu-outer.x-close-menu {
    font-size: 11px;
    width: 56px;
    height: 56px;
    line-height: 56px;
    margin: 0;
    font-family: otzar-new;
  }
  .icon-menu-outer {
    width: 24px;
    height: 24px;
    position: relative;
    /* margin-left: 9px; */
    margin-top: 16px;
    cursor: pointer;
    border-radius: 50%;
    transition: 0.3s;
    cursor: pointer;
    &.icon-back {
      margin-left: 9px;
    }
    &:hover {
      transition: 0.3s;
      background-color: #00000014;
    }
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
    }
  }
}
.fa {
  font-size: 20px;
  cursor: pointer;
}
.arrow-bake-menu {
  &:hover {
    .icon-menu-outer {
      transition: 0.3s;
      background-color: #00000014;
      cursor: pointer;
    }
  }
}
</style>
